var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMadad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        filter: url(#Path_221);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb109"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_221",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.388
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_154_28",
    "data-name": "Component 154 \\u2013 28",
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    className: "cls-1",
    width: 49,
    height: 63,
    rx: 24.5,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, -4.5, -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221-2",
    "data-name": "Path 221",
    className: "cls-2",
    d: "M31.5,0A31.5,31.5,0,1,1,0,31.5,31.5,31.5,0,0,1,31.5,0Z",
    transform: "translate(4.5 4.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Activity",
    "data-name": "Iconly/Bold/Activity",
    transform: "translate(15.001 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    className: "cls-1",
    d: "M20.175,2.67a7.11,7.11,0,0,0-.09,1.125,6.1,6.1,0,0,0,6.09,6.1,6.945,6.945,0,0,0,1.11-.1h0V21.9c0,5.086-3,8.1-8.1,8.1H8.1C3,30,0,26.985,0,21.9H0V10.8C0,5.7,3,2.67,8.1,2.67H20.175Zm.3,9.12a1.152,1.152,0,0,0-1.051.465h0L15.8,16.95,11.64,13.68a1.185,1.185,0,0,0-.855-.24,1.162,1.162,0,0,0-.75.448h0L5.6,19.665,5.5,19.8a1.121,1.121,0,0,0,.315,1.425,1.26,1.26,0,0,0,.69.225A1.063,1.063,0,0,0,7.395,21h0l3.765-4.846,4.275,3.211.135.088a1.122,1.122,0,0,0,1.425-.315h0l4.335-5.593-.06.03a1.123,1.123,0,0,0,.12-1.125A1.106,1.106,0,0,0,20.476,11.79ZM26.385,0A3.615,3.615,0,1,1,22.77,3.615,3.617,3.617,0,0,1,26.385,0Z",
    transform: "translate(0 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadad);
export default __webpack_public_path__ + "static/media/madad.5d9bc0820e79076fa97783b546b519b5.svg";
export { ForwardRef as ReactComponent };